module.exports = function () {
    // session sharing logic
    $(document).on('click', '.js-handle-session-sharing', function (e) {
        e.preventDefault();
        var url = $(this).attr('data-href');
        $.spinner().start();
        $.ajax({
            url: url,
            success: function (data) {
                if (!data.success) {
                    // if cookies are not returned then simpley redirect user to the url
                    window.location.href = data.redirectURL;
                } else {
                    // if we get cookies send a post request to a url for other site to set cookies
                    var redirect = $('<form>')
                        .appendTo(document.body)
                        .attr({
                            method: 'POST',
                            action: data.redirectURL
                        });

                    $('<input type="hidden">')
                        .appendTo(redirect)
                        .attr({
                            name: 'cookies',
                            value: JSON.stringify(data.cookies)
                        });
                    $('<input type="hidden">')
                        .appendTo(redirect)
                        .attr({
                            name: 'currency',
                            value: data.currencyCode
                        });
                    redirect.submit();
                }
            },
            error: function () {
                window.location.reload();
            }
        });
    });

    $(document).on('click', '.js-trigger-banner', function (e) {
        $('.js-handle-session-sharing').trigger('click');
    });
};
